export default {
	isPassive(str) {
		var supportsPassiveOption = false;
		try {
			addEventListener("test", null, Object.defineProperty({}, 'passive', {
				get: function() {
					supportsPassiveOption = true;
				}
			}));
		} catch(e) {}
		return supportsPassiveOption;
	},
	guid() {
		function S4() {
			return(((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
		}
		return(S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
	},
	autoCenter(el) {
		if(!el) {
			return;
		}
		//获取可见窗口大小
		var bodyW = document.documentElement.clientWidth;
		var bodyH = document.documentElement.clientHeight;
		//获取对话框宽、高		
		var elW = el.offsetWidth;
		var elH = el.offsetHeight || el.clientHeight;
		// debugger
		el.style.left = (bodyW - elW) / 2 + 'px';
		el.style.top = (bodyH - elH) / 2 + 'px';
	},
	GenNonDuplicateID(randomLength) {
		return Number(Math.random().toString().substr(3, randomLength) + Date.now()).toString(36)
	},
	goodTime(str) {
		let now = new Date().getTime()
		let oldTime = new Date(str).getTime()
		let difference = now - oldTime
		let result = ''
		let minute = 1000 * 60
		let hour = minute * 60
		let day = hour * 24
		let month = day * 30
		let year = month * 12
		let _year = difference / year
		let _month = difference / month
		let _week = difference / (7 * day)
		let _day = difference / day
		let _hour = difference / hour
		let _min = difference / minute

		if(_year >= 1) {
			result = '发表于 ' + ~~(_year) + ' 年前'
		} else if(_month >= 1) {
			result = '发表于 ' + ~~(_month) + ' 个月前'
		} else if(_week >= 1) {
			result = '发表于 ' + ~~(_week) + ' 周前'
		} else if(_day >= 1) {
			result = '发表于 ' + ~~(_day) + ' 天前'
		} else if(_hour >= 1) {
			result = '发表于 ' + ~~(_hour) + ' 个小时前'
		} else if(_min >= 1) {
			result = '发表于 ' + ~~(_min) + ' 分钟前'
		} else {
			result = '刚刚'
		}
		return result
	}
}


// WEBPACK FOOTER //
// ./src/utils/index.js